/*
    View to be used when the factory devicegroup list is empty.
    Include it as the CollectionView's emptyView option.
    Set emptyViewOptions to include the given product.
*/

import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

const template = `<h3>No Fixture Device Groups</h3>
To create a new Fixture Device Group, your Product must first contain at least one
<a class="prod-devicegroup" data-toggle="tooltip" title="View Product's Production Device Groups">Production Device Group</a> 
and one <a class="dut-devicegroup" data-toggle="tooltip" title="View Product's DUT Device Groups">DUT Device Group</a>.`;

var globalCh = Radio.channel('global');

var FactoryListEmptyView = Marionette.View.extend({
    className: 'text-center',
    template: Handlebars.compile(template),
    ui: {
        link_prod: 'a.prod-devicegroup',
        link_dut: 'a.dut-devicegroup'
    },
    events: {
        'click @ui.link_prod': function(e){
            e.preventDefault();
            globalCh.request('show_production_devicegroups', this.getOption('product'));
        },
        'click @ui.link_dut': function(e){
            e.preventDefault();
            globalCh.request('show_dut_devicegroups', this.getOption('product'));
        }
    },
    onRender: function () {
        this.ui.link_prod.tooltip();
        this.ui.link_dut.tooltip();
    },
    templateContext: function () {
        var id = this.getOption('product').id;
        return {
            id: id,
        };
    }
});

export default FactoryListEmptyView;

